export const projects = [
    {
        title: "Photofolio",
        description:
            "PhotoFolio is a sleek and dynamic photo album manager built with React, Firebase Firestore, and Bootstrap. It lets you create photo albums, upload and manage images, search, view them in a carousel, and more.",
        techStack: ["HTML", "CSS", "JavaScript", "React.js", "Firebase-database", "Firebase-realtime-database"],
        image: "/photoFolio.png",
        github: "https://github.com/nikitagupta1709/photofolio",
        live: "https://nikita-photofolio.netlify.app/",
    },
    {
        title: "Social Media Networking API",
        description:
            "Built a scalable social media backend with user posts, likes, comments, secure OTP authentication, and RESTful API architecture.",
        techStack: ["Node.js", "Express.js", "MongoDB", "Mongoose", "Nodemailer", "JWT"],
        image: "/social-media-rest-api.png",
        github: "https://github.com/nikitagupta1709/social_media_REST_API",
        live: "",
    },
    {
        title: "Job Portal Website",
        description:
            "Developed a role-based job portal for recruiters and seekers with secured CRUD operations and dynamic job listings.",
        techStack: ["HTML", "CSS", "JavaScript", "Node.js", "Express"],
        image: "/job-portal-website.png",
        github: "https://github.com/nikitagupta1709/Job_Portal_Website",
        live: "https://job-portal-website-1-g304.onrender.com/",
    },
    {
        title: "Alarm Clock",
        description:
            "This project is a web-based Alarm Clock that allows users to set alarms, snooze them, and manage multiple alarms. The application is built using HTML, CSS, and JavaScript, with a focus on a simple and interactive user interface.",
        techStack: ["HTML", "CSS", "JavaScript"],
        image: "/alarm-clock.png",
        github: "https://github.com/nikitagupta1709/alarm_clock",
        live: "https://setting-alarm-clock.netlify.app/",
    },
    {
        title: "Blog Website",
        description:
            "It is a blogging website where user can add, delete, view, and update the blogs. It is a full stack application with React.js, Node.js, Express.js, MongoDB, and Mongoose.",
        techStack: ["HTML", "CSS", "JavaScript", "React.js", "Node.js", "Express", "MongoDB", "Mongoose"],
        image: "/blog.png",
        github: "https://github.com/nikitagupta1709/nikita-blog",
        live: "https://nikita-blog-app.netlify.app/",
    },
    {
        title: "PharmEasy clone Website",
        description: "Online healthcare platform built by 4 members. Features include Redux and JSON-server for sign-up/login, dynamic navbar, functional search bar, and a products page with filters, sorting, and pagination using searchParams. Cart managed in Redux. Responsible for flow management, implementing persistent sorting, filtering, pagination, and deploying JSON-server on Heroku and frontend on Netlify.",
        techStack: ["HTML", "CSS", "JavaScript", "React.js", "Node.js", "Express", "MongoDB", "Mongoose"],
        image: "/pharmEasy.png",
        github: "https://github.com/nikitagupta1709/pharmaeasy-clone",
        live: "https://pharmeasy-site-clone.netlify.app/",
    },
];

export const skillCategories = [
    {
        title: 'Frontend Development',
        skills: [
            'React.js - Component-driven UI building',
            'HTML5 - Semantic web structure',
            'CSS3 - Responsive layouts & animations',
            'JavaScript - Interactive client logic',
            'Responsive Web Design - Mobile-first approach'
        ],
    },
    {
        title: 'Backend Development',
        skills: [
            'Node.js - Server-side JavaScript',
            'Express.js - RESTful API development',
            'MongoDB - Flexible document storage, NoSQL Database Design',
            'Mongoose - Data modeling & validation',
            'Firebase-realtime - Data management in real-time',
        ],
    },
    {
        title: 'AI & Chatbots',
        skills: [
            "Langchain",
            "Google’s Agentspace",
            "AI-based Chatbot Integration",
        ]
    },
    {
        title: 'Development Practices',
        skills: [
            'Git - Version Control',
            'Agile Methodologies - Scrum & Kanban',
            'Code Reviews - Collaborative improvement'
        ],
    },
    {
        title: 'Soft Skills',
        skills: [
            'Leadership - Guiding project teams',
            'Collaboration - Working cross-functionally',
            'Communication - Clear articulation of ideas'
        ],
    },
    {
        title: 'Others',
        skills: [
            'Google Cloud Platform (GCP) - Cloud deployments',
            'Docker - Containerization of apps',
            'Problem Solving - Analytical approach',
            'Continuous Learning - Always upgrading skills'
        ],
    }
];

export const experiences = [
    {
        role: "Associate Software Engineer",
        company: "Twinleaves",
        duration: "Feb 2023 – Present",
        logo: "/twinleaves_logo.jpg",
        details: [
            "AI Integration: Integrated an AI-powered Chatbot using Langchain and Google’s Agentspace, enabling real-time data retrieval from the website and improving user engagement by 20%",
            "Took ownership of the end-to-end development of key product features, delivered them on time and with a focus on scalability and performance. Resulted in an increase 30% in system efficiency.",
            " Accelerated development cycles by 30% by refactoring scalable code and adoption of design patterns, reducing bug reports by 15% and the time of the sprint cycle by one day.",
            "Drove CI/CD best practices, reducing deployment time by 40%, enabling more frequent and seamless releases with fewer rollbacks",
            "Mentored 5+ junior engineers, improved their productivity by 15% and enhancing the team’s overall skill set",
            "Led the development of a B2B product initiative, improving operational efficiency across multiple companies and reducing manual effort by 30%",
            "Integrated React Context API and Redux, reducing prop drilling by 60%, resulting in cleaner and more maintainable code.",
            "Established RBAC security, preventing 95% unauthorized access and ensuring compliance with industry standards."
        ],
    },
];